//External
import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
//Internal
import OtpInputBox from "../../components/login/otp-input";
import { ResenOtp } from "components/common";
import { REQUIRE_OTP } from "utils";

import verifyImg from "../../public/assets/images/verification-number.svg";

/*******************
@Purpose : Used for verify user exist otp modal
@Parameter : {hideHandler,handleOtpSubmit,showHandler}
@Author : INIC
******************/
function VerifyUserExistOtpModal({
  hideHandler,
  handleOtpSubmit,
  continueAsGuest,
  ResendOtp,
  showHandler,
  verifyOtpError,
}) {
  const [otp, setOtp] = useState("");
  const [showError, setShowError] = useState(false);
  const [clickCount, setClickCount] = useState(1);
  const [otpEnable, setOtpEnable] = useState(false);
  const [verifyOtpErrorMsg, setVerifyOtpErrorMsg] = useState(verifyOtpError);

  useEffect(() => {
    if (showHandler) {
      setTimeout(() => {
        document.querySelector(".otp-input-item").focus();
      }, 500);
    }
  }, [showHandler]);

  useEffect(() => {
    // setOtp("");
    setOtpEnable(false);
    handleClickCount();
    setVerifyOtpErrorMsg(verifyOtpError);
  }, [verifyOtpError]);

  /*******************
  @Purpose : OTP change handler
  @Parameter : {otp}
  @Author : INIC
  *******************/
  const handleChange = (otp) => {
    setShowError(false);
    setOtp(otp);
    if (otp.length == 6) {
      setOtpEnable(true);
      handleOtpSubmit(otp);
    }
  };

  /*******************
  @Purpose : Click on verify btn
  @Parameter : {otp}
  @Author : INIC
  *******************/
  const verifyClickHandler = (otp) => {
    if (otp) {
      setShowError(false);
      if (otp.length == 6) {
        hideHandler();
        handleOtpSubmit(otp);
      } else {
        setOtpEnable(false);
        setShowError(true);
      }
    } else {
      setShowError(true);
    }
  };

  /*******************
  @Purpose : reload otpinputbox
  @Parameter : {}
  @Author : INIC
  *******************/
  const handleClickCount = () => {
    setClickCount(clickCount + 1);
  };

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <Modal
      show={showHandler}
      onHide={hideHandler}
      className="vnotp-modal"
      dialogClassName="vnotp-modal-dialog"
      centered
    >
      <Modal.Header
        closeButton
        className="vnotp-modal-header justify-content-center"
      >
        {/* <div className="d-flex flex-column otp-heading">
          <h4 className="modal-title">You already have an active account</h4>
          <p className="mb-0 font-14">
            A verification code has been sent to the phone number we have on
            file
          </p>
        </div>
        <figure className="vnotp-modal-header-img">
          <img src={placeHolderImage} alt="Verify OTP Image" />
        </figure> */}
        <div className="otp-card-body p-0 mt-3">
          <img
            src={verifyImg}
            alt="otp banner image"
            width="200"
            height="auto"
            className="otp-img-web"
          />
          <div className="otp-title-box d-block">
            <h4 className="modal-title p-0">
              You already have an active account
            </h4>
            <p className="mb-0 font-14">
              A verification code has been sent to the phone number we have on
              file
            </p>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="vnotp-modal-body">
        <Form className="vnotp-modal-form">
          <div className="vnotp-content text-center">
            <legend>Enter Verification code</legend>
            <OtpInputBox
              handleChange={handleChange}
              otp={otp}
              clickCount={clickCount}
              otpEnable={otpEnable}
            />
            <ResenOtp
              resendOtp={() => {
                setVerifyOtpErrorMsg("");
                setOtp("");
                ResendOtp();
              }}
              handleClickCount={handleClickCount}
            />
          </div>
          <div className="btn-bottom text-center">
            {showError && (
              <span className="text-danger font-12 ff-hel-med text-left mb-1 d-block">
                {REQUIRE_OTP}
              </span>
            )}
            {verifyOtpErrorMsg && (
              <span className="text-danger font-12 ff-hel-med text-left mb-1 d-block">
                {verifyOtpErrorMsg}
              </span>
            )}

            <Button
              variant="primary"
              type="button"
              className={`w-100 font-16 ff-hel-med mb-2 text-center d-flex align-items-center justify-content-center gtStep1`}
              onClick={() => verifyClickHandler(otp)}
              disabled={!otp}
            >
              Verify
            </Button>
            <a
              onClick={continueAsGuest}
              className="d-block text-line font-14 mb-space-c text-decoration-underline text-center text-secondary"
            >
              Continue as a guest
            </a>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default VerifyUserExistOtpModal;
